// extracted by mini-css-extract-plugin
var _1 = "ApplicantIdentityWidgetContactRow-modulecontact__tQ1Rj";
var _2 = "ApplicantIdentityWidgetContactRow-modulecopyButton__HAxpK";
var _3 = "ApplicantIdentityWidgetContactRow-modulelabel__OaXSM";
var _4 = "ApplicantIdentityWidgetContactRow-modulevalue__GiVY0";
export { _1 as "contact", _2 as "copyButton", _3 as "label", _4 as "value" }
